import { useState, type ReactNode } from 'react'
import type { NativeSyntheticEvent, TextInputChangeEventData } from 'react-native'

import { Input } from '@/src/elements/input'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { useTranslate } from '@/src/lang/useTranslate'

const isValidEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)

type TWatchmanEmailInputProps = {
  onEmailChange: (email: string) => void
  onSubmitEditing: VoidFunction
  children: ({ errorMessage }: { errorMessage?: string }) => ReactNode
}
export const WatchmanEmailInput = ({
  onEmailChange: onEmailChangeProp,
  onSubmitEditing,
  children,
}: TWatchmanEmailInputProps): ReactNode => {
  const [email, setEmail] = useState('')
  const { t } = useTranslate()

  const errorMessage = email.length > 0 && !isValidEmail(email) ? t('common.form.error.email.invalid') : undefined

  const handleEmailChange = ({ nativeEvent: { text } }: NativeSyntheticEvent<TextInputChangeEventData>) => {
    setEmail(text)
    onEmailChangeProp(text)
  }

  return (
    <>
      <Input
        color="default"
        startIcon={ICON.MAIL}
        placeholder={t('words.your-email-address')}
        value={email}
        isError={email.length > 0 ? errorMessage != null : undefined}
        errorMessage={errorMessage}
        autoCapitalize="none"
        autoCorrect={false}
        onSubmitEditing={onSubmitEditing}
        onChange={handleEmailChange}
        testID={TEST_ID.ME.AUTHENTICATION.USERNAME_INPUT}
      />
      {children({ errorMessage })}
    </>
  )
}
